import { createSelector } from 'reselect'
import settingsHelper from '../../../helpers/utils/settings'
import settingsEnums from '../../../helpers/enums/settings'
import { IStore } from '../../reducers/index'

const settingsSelector = (state: IStore) => state.game.settings

export default createSelector(settingsSelector, (settings) => {
	const hideStudentNames = settingsHelper.getSettingValue(settings, settingsEnums.SETTING_TYPE_HIDE_STUDENT_NAMES)
	return hideStudentNames === 1
})
